import useLocalAudioInputActivityPreview from '@hooks/sdk/useLocalAudioInputActivityPreview';
import { useRef } from 'react';
import ActivityBar from '../ActivityBar';
import { Container, MicIcon } from './style';

const MicrophoneActivityPreview = () => {
  const activityBarRef = useRef<HTMLDivElement>(null);
  useLocalAudioInputActivityPreview(activityBarRef);

  return (
    <Container>
      <MicIcon src='/img/icon_mike.png' height={42} width={42} />
      <ActivityBar ref={activityBarRef} />
    </Container>
  );
};

export default MicrophoneActivityPreview;
